import React, { FC } from "react";

interface UnaffiliatedModalProps {
    isModalOpen: boolean;
    handleModalClose: () => void;
}

const modalStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const UnaffiliatedModal: FC<UnaffiliatedModalProps> = ({ isModalOpen, handleModalClose }) => {
    if (!isModalOpen) {
        return null;
    }

    return (
        <div className="fixed z-10 inset-0 overflow-y-auto" id="my-modal">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 sm:h-screen sm:items-center sm:flex sm:w-50% " style={modalStyle}>
                <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:h-fit"
                    role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div>
                        
                        <div className="mt-3 text-center sm:mt-5">
                            <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                ¡Ups! No pudimos completar tu registro
                            </h3>
                            <div className="mt-2">
                                <p className="text-sm text-gray-500 pl-5 pr-5">
                                Parece que hubo un problema al intentar registrar tu cuenta. Si no estás afiliado, no te preocupes, podés hacerlo completando <a href="https://setia.fire-bots.com/?tipo=OSSIN" target="_blank" className="text-blue-600">este formulario de afiliación</a>.
                                Si ya estás afiliado, contactanos y estaremos encantados de ayudarte.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 sm:mt-6">
                        <button
                            className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
                            onClick={handleModalClose}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnaffiliatedModal;